const SELECTOR = "[data-pdp-back-button]";

function hasInternalHistory() {
    if (window.history.length <= 1) return false;

    const referrer = document.referrer;
    if (!referrer) return false;

    try {
        return new URL(referrer).origin === window.location.origin;
    } catch (_) {
        return false;
    }
}

function isModifiedClick(event) {
    return (
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
    );
}

function handleClick(event) {
    if (event.defaultPrevented || isModifiedClick(event)) return;
    if (!hasInternalHistory()) return;

    event.preventDefault();
    window.history.back();
}

function init() {
    const button = document.querySelector(SELECTOR);
    if (!button || button.dataset.pdpBackButtonInit === "true") return;
    button.dataset.pdpBackButtonInit = "true";
    button.addEventListener("click", handleClick);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
} else {
    init();
}
